import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/organizationsActions'
import { constants as jobVendorConstants } from '../modules/jobFunctions/jobVendorActions'
import * as api from '../api/organization'

function* fetchOrganizations(action) {
  try {
    const payload = yield call(api.getOrganizationsList, action)
    yield put({ type: constants.GET_ALL_ORGANIZATIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_ORGANIZATIONS.FAILED,
      message: e.message || e
    })
  }
}

function* organizationsRefresh() {
  yield takeLatest(constants.GET_ALL_ORGANIZATIONS.ACTION, fetchOrganizations)
}

function* sagaQuickAddNewOrganization(action) {
  yield sagaCreateNewOrganization(action)
  yield put({ type: jobVendorConstants.GET_ALL_VENDORS.ACTION })
}

function* sagaCreateNewOrganization(action) {
  try {
    const payload = {
      organization_data: {
        type: action.organization.type,
        name: action.organization.name,
        work_number: action.organization.work_number,
        fax_number: action.organization.fax_number,
        address1: action.organization.address1,
        address2: action.organization.address2,
        city: action.organization.city,
        state: action.organization.state,
        zip: action.organization.zip
      },
      user_id: action.userId
    }

    yield call(api.createNewOrganization, payload)
    yield put({ type: constants.CREATE_NEW_ORGANIZATION.SUCCESS, payload })
    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_ORGANIZATION.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNewOrganization() {
  yield takeLatest(constants.CREATE_NEW_ORGANIZATION.ACTION, sagaCreateNewOrganization)
}

function* watchQuickAddNewOrganization() {
  yield takeLatest(constants.QUICK_ADD_NEW_ORGANIZATION.ACTION, sagaQuickAddNewOrganization)
}

export function* rootSaga() {
  yield all([
    fork(organizationsRefresh),
    fork(watchCreateNewOrganization),
    fork(watchQuickAddNewOrganization)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/organizationsSaga.js